import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=082bc332&"
import script from "./NotFound.vue?vue&type=script&lang=js&"
export * from "./NotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/jamievetrovsky/Documents/WorkDevelopment/product-return-portal-fe/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VContainer,VIcon})
